module.exports = __webpack_public_path__ + "img/twitter-logo.631cd566.svg";